export default __webpack_public_path__ + "static/Satoshi-Bold-subset-f14c46eb6818cdd38fb0e53607aae58e.woff2";